import { requestWriteAccessApi } from 'common/middleware/api';
import ToastActions, { showToast } from 'common/redux/actions/toast';
import { ToastTypes } from 'common/components/core/toast/Toast';
import { ApiError } from 'common/modules/api';
import I18nHelper from 'common/helpers/I18nHelper';

export class WriteAccessActions {
    static t = (key, options) =>
        I18nHelper.translate('translations', key, options);

    static requestWriteAccess = ({ clientId }) => {
        return dispatch => {
            const requestingWriteAccess = 'requestingWriteAccess';
            const toast = {
                active: true,
                message: WriteAccessActions.t(requestingWriteAccess),
                type: ToastTypes.Info,
                tag: requestingWriteAccess,
                timeout: 0
            };
            dispatch(showToast(toast));

            requestWriteAccessApi
                .fetch({ clientId, duration: 2 })
                .then(() => {
                    const toast = {
                        active: true,
                        message: WriteAccessActions.t('writeAccessSuccess'),
                        type: ToastTypes.Success
                    };
                    dispatch(
                        ToastActions.hideToastsByTag({
                            tag: requestingWriteAccess
                        })
                    );
                    dispatch(showToast(toast));
                })
                .catch(error => {
                    dispatch(
                        ToastActions.hideToastsByTag({
                            tag: requestingWriteAccess
                        })
                    );
                    if (error instanceof ApiError) {
                        const toast = {
                            active: true,
                            message: error.message,
                            type: ToastTypes.Error
                        };
                        dispatch(showToast(toast, { clientId }));
                    } else {
                        throw error;
                    }
                });
        };
    };
}

export default WriteAccessActions;
